import { madeRequest } from '../../helpers/api'
import { ENDPOINTS } from '../../constants/api'

// PLOP_APPEND_PATTERN_ANCHOR

export function getSelfAccountsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.accounts
  })
}

export async function getSelfAccountService(id, showErrorToast = true) {
  return madeRequest('GET', {
    url: `${ENDPOINTS.accounts}${id}/`,
    showErrorToast
  })
}

export function createSelfAccountService(selfAccountData) {
  return madeRequest('POST', {
    data: selfAccountData,
    url: ENDPOINTS.accounts
  })
}

export function updateSelfAccountService(id, selfAccountData) {
  return madeRequest('PATCH', {
    data: selfAccountData,
    url: `${ENDPOINTS.accounts}${id}/`
  })
}
